import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
} from '@mui/material';

export const TimeoutWarningModal = ({ isOpen,  onLogout  }) => {
    const [secondsLeft, setSecondsLeft] = useState(30);

    useEffect(() => {
        if (!isOpen) return;

        setSecondsLeft(30); // Reset timer on modal open

        const intervalId = setInterval(() => {
            setSecondsLeft(prev => prev - 1);
        }, 1000);

        const timeoutId = setTimeout(() => {
            onLogout();
        }, 30000);

        return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
        };
    }, [isOpen, onLogout]);

    return (
        <Dialog
            open={isOpen}
            onClose={(e, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
            }}
            disableEscapeKeyDown
        >
            <DialogTitle>Session Timeout</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You're being timed out due to login expiration. You will be redirected automatically to login in <strong>{secondsLeft}</strong> seconds.
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

